// === CONSTANTES DEL ESTADO DE RESULTADOS ===

export const meses = ["ENE", "FEB", "MAR", "ABR", "MAY", "JUN", "JUL", "AGO", "SEP", "OCT", "NOV", "DIC"];

export const mesesCompletos = [
  "enero",
  "febrero",
  "marzo",
  "abril",
  "mayo",
  "junio",
  "julio",
  "agosto",
  "septiembre",
  "octubre",
  "noviembre",
  "diciembre",
];

// === CONFIGURACIÓN CENTRALIZADA DE COSTOS FIJOS ===
export const camposCostosFijos = [
  "oficina",
  "transporte",
  "telefonia",
  "marketing",
  "contador",
  "abogados",
  "gastos_representacion",
  "asesoria_externa",
  "alojamiento",
  "viajes_gerencia",
  "gastos_bancarios",
  "varios",
];

export const nombresCostosFijos = [
  "Oficina",
  "Transporte",
  "Telefonía",
  "Marketing",
  "Contador",
  "Abogados",
  "Gastos representación",
  "Asesoría externa",
  "Alojamiento",
  "Viajes Gerencia",
  "Gastos Financieros",
  "Varios",
];

export const conceptosManuales = ["Servicios internet", "Software DS", "Mantenimiento"];

// Configuración centralizada por país (locale, moneda, URLs de dólar)
export const COUNTRY_CONFIG = {
  Chile: {
    locale: "es-CL",
    moneda: "$ ",
    dolarUrl: "https://wecast.cl/services/dolar/dolar.json",
    dolarLocalPath: "dolarchile",
  },
  Perú: {
    locale: "es-PE",
    moneda: "S/ ",
    dolarUrl: "https://visiona.pe/services/dolar/dolar.json",
    dolarLocalPath: "dolarperu",
  },
};

// Intereses del holding (en USD/mes) — VALOR PROVISORIO puesto a mano hasta el
// módulo de pasivos (cuotas de interés/capital). La deuda del holding se reparte
// 50/50 entre Chile y Perú: cada país paga la mitad de cada préstamo.
// Fuente única de verdad: el desglose por préstamo con el total del holding.
// De acá se derivan tanto la fila del ER como el InteresesModal (no duplicar literales).
const PROPORCION_PAIS = 0.5; // Chile y Perú pagan mitad y mitad

// Total holding por préstamo (USD/mes), antes del reparto por país.
const interesesHoldingPorPrestamo = [
  { nombre: "Connolly", totalHolding: 1676 },
  { nombre: "Otegui", totalHolding: 212 },
];

// Desglose por préstamo del monto que paga CADA país (50% del total holding).
// Connolly 838, Otegui 106 → Total 944. Lo consume el InteresesModal.
export const interesesDesglosePorPais = interesesHoldingPorPrestamo.map((p) => ({
  nombre: p.nombre,
  montoPais: Math.round(p.totalHolding * PROPORCION_PAIS),
}));

// Total mensual por país (USD) = suma del desglose. Se conserva exactamente la
// forma { Chile, Perú } que consumen los cálculos del ER para no romper nada.
const interesMensualPorPais = interesesDesglosePorPais.reduce((sum, p) => sum + p.montoPais, 0);

export const interesesMensualesUSD = {
  Chile: interesMensualPorPais, // 944
  Perú: interesMensualPorPais, // 944
};

// Impuestos mensuales por país (en USD) - actualmente 0
export const impuestosMensualesUSD = {
  Chile: 0,
  Perú: 0,
};

// Valor fijo de asesoría externa para 2026: US$ 3.000 mensuales hasta mayo 2026.
// Desde junio 2026 Ignacio pasa a empleado Chile (proveedor id=1 desactivado como
// recurrente) → 0 para no proyectar asesoría externa en meses sin fila real (jun+).
// Los meses ene-may 2026 tienen fila real en costos_fijos y no dependen de esta constante.
export const ASESORIA_EXTERNA_USD_2026 = 0;

/**
 * Reordena 2 arrays de 12 elementos en una ventana rodante de los últimos 12 meses.
 * Ej: monthsToShow=1 (Feb 2026) → [prev[1], prev[2], ..., prev[11], curr[0]]
 * Ej: monthsToShow=7 (Ago 2026) → [prev[7], prev[8], ..., prev[11], curr[0], ..., curr[6]]
 */
export function windowArray(current, previous, monthsToShow) {
  const result = [];
  for (let j = 0; j < 12 - monthsToShow; j++) {
    result.push(previous[monthsToShow + j] || 0);
  }
  for (let j = 0; j < monthsToShow; j++) {
    result.push(current[j] || 0);
  }
  return result;
}
